var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#128abc;stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 122.778,
    y1: 53.172,
    x2: 118.988,
    y2: 71.977
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: " M127.138,20.998c8.662,0.528,15.252,7.976,14.733,16.636c-0.534,8.669-7.976,15.263-16.638,14.727 c-8.662-0.512-15.259-7.965-14.74-16.636C111.027,27.074,118.476,20.473,127.138,20.998z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: " 172.606,234.466 172.606,186.071 222.721,186.071  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.312,
    y1: 113.687,
    x2: 186.653,
    y2: 113.687
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 69.312,
    y1: 146.364,
    x2: 186.653,
    y2: 146.364
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: " 113.018,46.273 33.279,46.273 33.279,235.031 179.03,235.031 222.693,197.234 222.693,46.273 139.381,46.273  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.9d8ed54d7cdbd3c402b8dd0c170d07ab.svg";
export { ForwardRef as ReactComponent };